import $ from "jquery";

$(function () {
  if (typeof hbspt === "undefined") {
    console.error("HubSpot script not loaded");
    return;
  }

  hbspt.forms.create({
    region: "na1",
    portalId: "21790357",
    target: "#obesity_guide_form",
    formId: "4bcf6672-bb0b-4b57-bba5-6d18516c964d",
    onFormReady: function ($form, ctx) {
      // find the empty option and update the text
      $('select[name="specialty"]', $form)
        .find("option")
        .each(function () {
          if ($(this).val() === "") {
            $(this).text("Select");
          }
        });
      $('#label-npi-4bcf6672-bb0b-4b57-bba5-6d18516c964d span', $form).text("NPI");
    },
    onFormSubmit: function ($form) {
      // Prevent the default form submit action which causes the scroll to top
      $form.on('submit', function (e) {
        e.preventDefault();
        // Perform any additional actions you want here
      });
    },

    onFormSubmitted: function ($form) {

      dataLayer.push(
        {
          'event': 'obesity_discussion_guide',
          'page_name': 'resources_obesity'
        }
      );
      console.log("DataLayer event pushed for obesity discussion guide");
      // Prevent scrolling to the top after form submission
      $form.closest('.modal-body').scrollTop($form.closest('.hs-form').offset().top);
    }
  });
});
